// Module
var code = "<h1> <router-link :class=\"[appMode]\" id=\"respresso-logo\" :to=\"{name: 'teams'}\" title=\"Respresso - For stress free multiplatform developement\"></router-link> </h1>";
// Exports
module.exports = code;